import { create } from 'zustand';

/**
 * Tracks how many `<UploadInput>` instances are currently busy compressing or
 * processing files. Components hosting Save buttons can read `inFlight > 0`
 * (or use the `useIsUploading` selector) to disable submit while uploads are
 * in progress, preventing partial saves.
 */
export const useUploadStatusStore = create((set, get) => ({
  inFlight: 0,
  start: () => set({ inFlight: get().inFlight + 1 }),
  end: () => set({ inFlight: Math.max(0, get().inFlight - 1) }),
}));

export const useIsUploading = () => useUploadStatusStore((s) => s.inFlight > 0);
